$(document).ready(function () {
  $('.search-services__category').on('click', function () {
    $(this).next().slideToggle();
  });
});

$(document).ready(function () {
  $('.about__btn, .metamorphoses__btn, .contact-specialists__btn').on('click', function (event) {
    event.preventDefault();

    let id = $(this).attr('href');
    let top = $(id).offset().top - 150;

    $('body,html').animate({ scrollTop: top }, 1500);
  });
});
